import './index.css';
import {heatLayer} from "./map";
import {heatData} from "./data";
import {rangeSliderInstance} from "./web-components/range-slider";
import "./popup";

heatLayer.setLatLngs(heatData());

document.querySelector('body').append(rangeSliderInstance);
